import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TAccountClient, adaptAccountClientFromResponse } from 'src/store';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_CLIENT } from '../../backend-paths';


export const accountClientDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ACCOUNT_CLIENT}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ACCOUNT_CLIENT}/${payload}`;

		return HttpService.delete(path).then(result => {
			return adaptAccountClientFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TAccountClient> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountClientDeleteSlice = createSlice({
	name: 'accountClientDeleteSlice',
	initialState,
	reducers: {
		clearAccountClientDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountClientDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountClientDeleteApi.fulfilled.type]: (state, action: PayloadAction<TAccountClient>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountClientDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountClientDeleteSelector = () => useAppSelector(state => state[accountClientDeleteSlice.name]);

export const { clearAccountClientDelete } = accountClientDeleteSlice.actions;
